export * from './menus'

export const CREATE_POLICY_URL = 'https://pdpa.pro/create/policy'
